import { Text } from 'slate';

export const normalizeNodeShouldHaveData = (node) => {
  if (node && (!!node.type || Text.isText(node))) {
    return node;
  }

  if (node instanceof Array) {
    return node;
  }

  return null;
};
